import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'

const query = `
  query ShopifySearchCustomers(
    $query: String!
  ) {
    customers(first: 1, query: $query) {
      edges {
        node {
          id
        }
      }
    }
  }
`

const doFetchCustomerId = (integrationId, contactId, email) => dispatch => {
  const variables = { query: `email:"${email}"` }

  return dispatch(
    doGraphqlRequest('shopify/FETCH_CUSTOMER_ID', query, variables, {
      graphqlFunc: graphql(integrationId),
    })
  ).then(data => {
    if (data?.customers?.edges?.length > 0) {
      const first = data.customers.edges[0]
      return first?.node?.id
    }
    return null
  })
}

export default doFetchCustomerId
